import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/illustrations/criticality.svg'


const _hoisted_1 = { class: "card" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_img = _resolveComponent("v-img")!
  const _component_CustomButton = _resolveComponent("CustomButton")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createBlock(_component_v_row, { class: "ma-4 mpc-criticality mx-auto" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_col, { class: "pa-0" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_img, {
            src: _imports_0,
            height: "44px",
            width: "44px",
            class: "mx-auto"
          }),
          _cache[3] || (_cache[3] = _createElementVNode("div", { class: "token-text-h4 mb-2 text-center" }, " Cluster criticality ", -1)),
          _cache[4] || (_cache[4] = _createElementVNode("div", { class: "token-text-regular mb-6 text-center" }, " What is you goal for this environment? ", -1)),
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_CustomButton, {
              class: "full-width mb-2",
              level: _ctx.$enums.ButtonLevels.Secondary,
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:criticality', _ctx.$enums.ClusterCriticality.BASIC)))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.descriptions[_ctx.$enums.ClusterCriticality.BASIC].main), 1)
              ]),
              _: 1
            }, 8, ["level"]),
            _createVNode(_component_CustomButton, {
              class: "full-width mb-2",
              level: _ctx.$enums.ButtonLevels.Secondary,
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:criticality', _ctx.$enums.ClusterCriticality.STABLE)))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.descriptions[_ctx.$enums.ClusterCriticality.STABLE].main), 1)
              ]),
              _: 1
            }, 8, ["level"]),
            _createVNode(_component_CustomButton, {
              class: "full-width mb-2",
              level: _ctx.$enums.ButtonLevels.Secondary,
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('update:criticality', _ctx.$enums.ClusterCriticality.MISSION_CRITICAL)))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.descriptions[_ctx.$enums.ClusterCriticality.MISSION_CRITICAL].main), 1)
              ]),
              _: 1
            }, 8, ["level"])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}